import LoadingSpinner from '@zenbusiness/zui/LoadingSpinner';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

import { LoadingContainerStyle, SpinnerContainer, SpinnerRoot } from './styles';

const LoadingContainerStyled = styled(Stack)(LoadingContainerStyle);
const LoadingContainerSpinner = () => (
  <LoadingContainerStyled aria-label="Loading animation">
    <SpinnerRoot>
      <SpinnerContainer>
        <LoadingSpinner />
      </SpinnerContainer>
    </SpinnerRoot>
  </LoadingContainerStyled>
);

export default LoadingContainerSpinner;
